import { Divider } from '@mui/material';

export function CardHeaderDivider() {
  return <Divider sx={{ marginTop: '16px', borderColor: '#D9D9D9' }} />;
}
